class Pacient {
    constructor() {
        this.ubs = " - UBS Santa Mônica"
        this.id = {
            'name': '',
            'cns': '',
            'birthday': '',
            'companion': '',
            'ethnicity': '',
            'age': '',
            'bornAt': '',
            'residence': ''
        };
        this.subjective = {
            'qp': '',
            'hpma': '',
            'ic': '',
            'ap': '',
            'vaccine': '',
            'foodIntake': '',
            'neurologic': ''
        };
        this.objective = {
            'antropometria': {
                'weight': 0,
                'height': 0,
                'bmi': 0
            },
            'imc': '',
            'ssvv': '',
            'overall': '',
            'specific': ''
        };
        this.evaluation = {
            'evaluation': ''
        };
        this.procedure = {
            'procedure': ''
        };
    }
}

export default Pacient